import React from 'react';
import { graphql } from 'gatsby';
import { Container, Row, Col } from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import parse from 'html-react-parser';
import SEO from '../components/seo';

import companyImg from '../images/company-thumbnail.png';
import arrow4 from '../images/arrow4.svg';
import circle from '../images/circle.svg';
import avatar from '../images/avatar.svg';
import charliAvatar from '../images/charli-avatar.svg';
import purpleBubble from '../images/purple-circle.svg';
import redBubble from '../images/red-bubble.svg';
import redCircle from '../images/red-circle.svg';
import greenBubble from '../images/green-bubble.svg';
import blueCircle from '../images/blue-circle.svg';
import lines from '../images/lines.svg';
import phoneIcon from '../images/phone-icon.svg';
import channelsIcon from '../images/multi-channel.svg';
import easyIcon from '../images/easy-icon.svg';
import intelligentIcon from '../images/intelligent-icon.svg';
import CompanyGraphic1 from '../images/Company_graphic1.svg';
import CompanyGraphic2 from '../images/Company_graphic2.svg';
import person1 from '../images/person1.png';
import person2 from '../images/person2.png';
import person3 from '../images/person3.png';
import person4 from '../images/person4.png';
import person5 from '../images/person5.png';
import person6 from '../images/person6.png';
import person7 from '../images/person7.png';

import '../styles/about-us.scss';

const AboutUs = (props) => {
  const { data } = props;
  return (
    <>
      <SEO
        title="About Us"
        description="Chat with our sales team about how Charli can support your business."
        image={companyImg}
      />
      <Container fluid className="section-banner">
        <Row>
          <Col md="12" lg="6">
            <h1 className="page-header">
              Get more life in your work-life balance
            </h1>
            <p>
              Charli was founded to fix the way we work by freeing up admin time
              for what matters most.
            </p>
            <div className="button-teal short">
              <a
                href="https://charliai.typeform.com/to/IhzcZhjI"
                target="_blank"
                rel="noreferrer"
              >
                Request Access
              </a>
            </div>
          </Col>
          <Col md="12" lg="6">
            <div className="product-banner-thumbnail">
              <img
                className="product-hero-img"
                src={companyImg}
                alt="charli-ai"
              />
            </div>
            <Parallax
              className="red-bubble wow"
              y={[20, -100]}
              tagOuter="figure"
            >
              <img src={redBubble} data-wow-delay="0.25s" alt="charli-ai" />
            </Parallax>
            <Parallax className="circle wow" y={[20, -100]} tagOuter="figure">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </Parallax>
            <Parallax
              className="purple-dot wow"
              y={[20, -200]}
              tagOuter="figure"
            >
              <img src={purpleBubble} alt="charli-ai" />
            </Parallax>
          </Col>
        </Row>
      </Container>
      <Container fluid className="section-company-page">
        <Parallax className="green-bubble wow" y={[20, -100]} tagOuter="figure">
          <img src={greenBubble} data-wow-delay="0.5s" alt="charli-ai" />
        </Parallax>
        <Container>
          <Row>
            <Col
              sm="12"
              md="12"
              className="homepage-fluid-content--title company-text-span"
            >
              <h2>
                We’re on a mission to make automating your admin
                <span>
                  “stuff”
                  <i className="underline wow" />
                </span>
                easy.
              </h2>
              <p>
                We believe admin should be as simple as texting or emailing an
                assistant who learns about you, the things you need to manage,
                and how you like to work — but without the cost of hiring
                someone. That’s why we built Charli, the world’s first AI chief
                of stuff.
              </p>
            </Col>
          </Row>
          <Row className="section-company-page--body">
            <Col md="6" sm="12">
              <h3>We’ve tried it all.</h3>
              <p>
                To cut down on our own time-consuming busy work, we tried
                everything from virtual EA apps to chat apps like Alexa and Siri
                and other assistants. But nothing we tried could set up the
                types of business workflows we needed to actually get stuff
                done.
              </p>
            </Col>
            <Col md="6" sm="12">
              <img
                className="wow"
                src={CompanyGraphic1}
                data-wow-delay="0.25s"
                alt="charli-ai"
              />
            </Col>
          </Row>
          <Row className="section-company-page--body">
            <Col md="6" sm="12">
              <img
                className="wow"
                src={CompanyGraphic2}
                data-wow-delay="0.5s"
                alt="charli-ai"
              />
            </Col>
            <Col md="6" sm="12">
              <h3>Better luck next time.</h3>
              <p>
                The existing technologies were rigid and static, with very
                limited ability to learn, optimize and adapt. Even simple
                workflow customizations required coding or scripting and a lot
                of time. It should be easier to get this stuff done.
              </p>
            </Col>
          </Row>
          <Row className="section-company-page--body">
            <Col md="12" className="charli-highlight-section">
              <h3>
                We realized we needed a <span>Charli.</span>
              </h3>
              <img
                className="wow"
                src={arrow4}
                data-wow-delay="0.25s"
                alt="charli-ai"
              />
              <div className="charli-highlight">
                <p>
                  The name
                  <br />
                  <strong>“Charli”</strong>
                  <br />
                  is a play on
                  <strong>
                    <br />
                    “Chief of Stuff.”
                  </strong>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="section-company-vision">
        <Container>
          <Row>
            <Col md="12" className="charli-vision">
              <h3>Our vision</h3>
            </Col>
          </Row>
          <Row className="charli-vision-content">
            <Col md="6" lg="3" sm="12" className="charli-vision-item">
              <img src={phoneIcon} alt="phone-icon" />
              <p>
                <strong>Just one tool</strong>
              </p>
              <p>
                One app, like one person, that a user could turn to for all
                their time-consuming administrative tasks.
              </p>
            </Col>
            <Col md="6" lg="3" sm="12" className="charli-vision-item">
              <img src={channelsIcon} alt="phone-icon" />
              <p>
                <strong>Multi-channel</strong>
              </p>
              <p>
                The ability to talk to this “chief of stuff” across multiple
                channels (such as text, chat, email and voice) just like a real
                person.
              </p>
            </Col>
            <Col md="6" lg="3" sm="12" className="charli-vision-item">
              <img src={easyIcon} alt="phone-icon" />
              <p>
                <strong>Easy</strong>
              </p>
              <p>
                Remove the burden of work, and the stress of having to remember
                everything, which many entrepreneurs and professionals face
                daily.
              </p>
            </Col>
            <Col md="6" lg="3" sm="12" className="charli-vision-item">
              <img src={intelligentIcon} alt="phone-icon" />
              <p>
                <strong>Intelligent</strong>
              </p>
              <p>
                Charli would learn about the user - their needs, preferences,
                workflows and processes - rather than users having to learn
                Charli.
              </p>
            </Col>
          </Row>

          <Row>
            <Col md="12" className="line-links">
              <img
                className="wow"
                src={lines}
                data-wow-delay="0.25s"
                alt="charli-ai"
              />
            </Col>
            <Col md="12" className="charli-vision-cta">
              <p>
                <strong>
                  Armed with a team of highly talented engineers, developers and
                  data scientists, this is exactly what we’ve done.{' '}
                </strong>
              </p>
              <p>
                We’ve built an app that’s solved a big problem for busy business
                leaders - from solopreneurs, to consultants, to business owners,
                to sales road warriors and more.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="12" className="charli-vision-cta">
              <h2>
                Now, thanks to Charli, we’re finally getting the life back in
                our <span>#WorkLifeBalance</span>
              </h2>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="section-company-members">
        <Container>
          <Row>
            <Col md="12">
              <div className="section-company-members--container">
                <Parallax
                  className="green-bubble-2 wow"
                  y={[20, -100]}
                  tagOuter="figure"
                >
                  <img
                    src={greenBubble}
                    data-wow-delay="0.5s"
                    alt="charli-ai"
                  />
                </Parallax>
                <Parallax
                  className="red-circle wow"
                  y={[20, -20]}
                  tagOuter="figure"
                >
                  <img src={redCircle} alt="charli-ai" />
                </Parallax>

                <Parallax
                  className="blue-circle wow"
                  y={[20, -20]}
                  tagOuter="figure"
                >
                  <img src={blueCircle} alt="charli-ai" />
                </Parallax>
                <img
                  src={person1}
                  alt="charli-ai"
                  className="person1 wow"
                  data-wow-delay="0.25s"
                />
                <img
                  src={person2}
                  alt="charli-ai"
                  className="person2 wow"
                  data-wow-delay="0.5s"
                />
                <img
                  src={person3}
                  alt="charli-ai"
                  className="person3 wow"
                  data-wow-delay="0.75s"
                />
                <img
                  src={person4}
                  alt="charli-ai"
                  className="person4 wow"
                  data-wow-delay="1s"
                />
                <img
                  src={person5}
                  alt="charli-ai"
                  className="person5 wow"
                  data-wow-delay="1.25s"
                />
                <img
                  src={person6}
                  alt="charli-ai"
                  className="person6 wow"
                  data-wow-delay="1.5s"
                />
                <img
                  src={person7}
                  alt="charli-ai"
                  className="person7 wow"
                  data-wow-delay="1.75s"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="cta-section">
        <Container>
          <Row className="company-cta-banner">
            <Col md="12" className="cta-title">
              <h3>
                Have you met{' '}
                <span>
                  Charli
                  <i className="underline wow" />
                </span>{' '}
                yet
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md="12" className="button-container">
              <div className="footer-button-wrapper">
                <div className="button-transparent">
                  <a
                    href="https://charliai.typeform.com/to/IhzcZhjI"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Sign up for free
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="section-team-leaders">
        <Container>
          <Row>
            <Col md="12" className="section-team-leaders--heading">
              <h3>The team behind Charli</h3>
            </Col>
          </Row>
          <Row className="section-team-leaders--container">
            {data.allWordpressWpMember.edges.map((item) =>
              // eslint-disable-next-line eqeqeq
              item.node.member_category.includes(18) ? ( // leaders category
                <Col
                  lg="4"
                  md="6"
                  sm="12"
                  key={item.node.id}
                  className="section-team-leaders--info"
                >
                  <img
                    src={
                      item.node.featured_media
                        ? item.node.featured_media.source_url
                        : charliAvatar
                    }
                    alt={item.node.title}
                    className="leader-img"
                  />
                  <div className="section-team-leaders--details">
                    <strong>{parse(item.node.title)}</strong>
                    <span>{parse(item.node.excerpt)}</span>
                    {/* {parse(item.node.content)} */}
                  </div>
                </Col>
              ) : null
            )}
          </Row>
        </Container>
      </Container>
      <Container fluid className="section-company-members-2">
        <Container>
          <Row>
            {data.allWordpressWpMember.edges.map((item) =>
              // eslint-disable-next-line eqeqeq
              item.node.member_category.length == 0 ? ( // not in leaders category
                <Col
                  lg="4"
                  md="12"
                  key={item.node.id}
                  className="section-team-members--info"
                >
                  <img
                    src={
                      item.node.featured_media
                        ? item.node.featured_media.source_url
                        : charliAvatar
                    }
                    alt={item.node.title}
                    className="member-img"
                  />
                  <div className="section-team-members--details">
                    <strong>{parse(item.node.title)}</strong>
                    <span>{parse(item.node.excerpt)}</span>
                    {/* {parse(item.node.content)} */}
                  </div>
                </Col>
              ) : null
            )}
            <Col lg="4" md="12" className="section-team-members--info">
              <img src={avatar} alt="candidate" className="member-img" />
              <div className="section-team-members--details">
                <strong>This could be you</strong>

                <span>
                  <p>Join our team</p>
                </span>

                <p>
                  We plan to grow fast, if you want to help us grow, contact{' '}
                  <a href="mailto:careers@charli.ai">careers@charli.ai</a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default AboutUs;
export const pageQuery = graphql`
  query {
    allWordpressWpMember(sort: { fields: date }) {
      edges {
        node {
          id
          excerpt
          content
          featured_media {
            source_url
          }
          title
          member_category
        }
      }
    }
  }
`;
